import React from 'react';
import {Bogies} from "./Bogies";
import {HVAC} from "./HVAC";
import {Doors} from "./Doors";

export const CarView = ({CommonService, ConditionService, EventsService, $uibModal}) => {
  const carNumber = CommonService.getSelectedCar();
  const trainNumber = CommonService.getSelectedTrain();

  // Anything with doors needs extra space at the top, or it will look crowded.
  const extraSpace = __env.profile ==='DEMO' ? {top: "20%"} : {};
  return (
    <div id="CarViewGridletContainer">
      <div className="car" style={extraSpace}>
        <Bogies carNumber={carNumber}
                ConditionService={ConditionService}
                EventsService={EventsService}
                $uibModal={$uibModal}/>
        {__env.profile ==='DEMO' && <HVAC carNumber={carNumber}
               ConditionService={ConditionService}
               $uibModal={$uibModal}/>}
        {__env.profile ==='DEMO' && <Doors carNumber={carNumber}
               ConditionService={ConditionService}
               $uibModal={$uibModal}/>}
      </div>
    </div>
  )
};